export default __webpack_public_path__ + "static/badge-dont-2-bold-light-94e89c14c7ea9914a87c834fe06b6975587f0ad7efd97afda9cd1c550716510d.png";